<template lang="pug">
.wrapper
    .container.m-auto
        header.header-page-global.flex.items-center.justify-between.py-4
            .header-page-global__meta
                h1.heading Components
            .header-page-global__cta
                ul.breadcrumb.flex.items-center.justify-between
                    li
                        a Home
                    li
                        a result
                    li
                        span overall
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Component
                    .header-cta
                        span
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            .box__body
                .box-tabs
                    vue-tabs
                        v-tab(title="Cart component")
                            ChartComponent

                        v-tab(title="Lists component")
                            ListsComponent

                        v-tab(title="Grids component")
                            GridComponent

                        v-tab(title="Buttons component")
                            ButtonsComponent

                        v-tab(title="Table component")
                            TableComponent

                        v-tab(title="Form component")
                            FormComponent
</template>

<script>
import FormComponent from './../components/Form.vue'
import TableComponent from './../components/Table.vue'
import ButtonsComponent from './../components/Buttons.vue'
import GridComponent from './../components/Grids.vue'
import ListsComponent from './../components/Lists.vue'
import ChartComponent from './../components/Chart.vue'
import {VueTabs, VTab} from 'vue-nav-tabs'

export default {
    name: 'result',
    components: {
        FormComponent,
        TableComponent,
        ButtonsComponent,
        GridComponent,
        ListsComponent,
        ChartComponent,
        VueTabs,
        VTab,
    },
}
</script>

<style lang="sass">

</style>


